const angular = require('angular');

const { onBlurDirectiveDefinition } = require('./on-blur.directive');

angular.module('oly.common')
    .directive('olyOnBlur', [onBlurDirectiveDefinition]);



// WEBPACK FOOTER //
// ./src/olycommon/onblur/index.js